import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { Options } from '@angular-slider/ngx-slider';
import { NgxSliderModule } from '@angular-slider/ngx-slider';

@Component({
  selector: 'app-intensity-rating',
  imports: [CommonModule, NgxSliderModule],
  templateUrl: './intensity-rating.component.html',
  styleUrl: './intensity-rating.component.scss',
})
export class IntensityRatingComponent {
  @Output() ratingConfirmed = new EventEmitter<number>();

  firstClicked: boolean = false;

  value: number = 5;
  options: Options = {
    showTicksValues: true,
    stepsArray: [
      { value: 1 },
      { value: 2 },
      { value: 3 },
      { value: 4 },
      { value: 5 },
      { value: 6 },
      { value: 7 },
      { value: 8 },
      { value: 9 },
    ],
    getPointerColor: () => (this.firstClicked ? 'darkblue' : 'transparent'),
  };

  onRatingClicked() {
    this.firstClicked = true;
  }

  onConfirmButtonClicked() {
    this.ratingConfirmed.emit(this.value);
  }
}
